import { lazy } from 'react';
import { paths } from '../../routes/paths';
import { ROLES } from '../../auth/roles';

// The organiser panel's sections in sidebar order (the Figma menu). Like the admin's list, this one
// drives both the routes and the sidebar. `roles` limits a section to the account owner: staff only
// check people in, so they don't see company or staff management.
// `soon` sections need reporting and notifications, which aren't built yet.
const OWNER = [ROLES.ORGANISER_OWNER];

export const ORGANISER_SECTIONS = [
  { key: 'dashboard', label: 'Dashboard', path: paths.organiser.dashboard, end: true, Component: lazy(() => import('./Overview')) },
  {
    key: 'events', label: 'Events', path: paths.organiser.events, splat: true,
    // the create/edit steps are titled "Create event" in the top bar, as in the Figma
    titleFor: (p) => (/\/events\/(new|\d+)/.test(p) ? 'Create event' : null),
    Component: lazy(() => import('./events/EventsRoutes')),
  },
  { key: 'ticket-types', label: 'Ticket types', path: paths.organiser.ticketTypes, splat: true, Component: lazy(() => import('./TicketTypesRoutes')) },
  // the Figma puts the orders inside Payouts (Payouts > Orders), so they are a sub-page here, not a menu item
  { key: 'payouts', label: 'Payouts', path: paths.organiser.payouts, splat: true, roles: OWNER, Component: lazy(() => import('./PayoutsRoutes')) },
  // the sales report is the owner's (report.view): staff only check people in
  { key: 'reports', label: 'Reports', path: paths.organiser.reports, roles: OWNER, Component: lazy(() => import('./Reports')) },
  { key: 'broadcast', label: 'Broadcast', path: paths.organiser.broadcast, soon: 'Messages to your attendees will be sent from here once ticket purchases and notifications are built.' },
  { key: 'staff', label: 'Staff', path: paths.organiser.staff, roles: OWNER, Component: lazy(() => import('./StaffOrganiser')) },
  { key: 'company-profile', label: 'Company profile', path: paths.organiser.companyProfile, roles: OWNER, splat: true, Component: lazy(() => import('./CompanyProfile')) },
];
